(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/media-queries/desktop.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/media-queries/desktop.js');

'use strict';

const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const activeMethodAtom = svs.iam_idp.atoms.activeMethodAtom;
const loginMethods = svs.iam_idp.constants.loginMethods;
const BankIdMain = svs.iam_idp.components.bank_id.BankIdMain;
const FrejaMain = svs.iam_idp.components.freja.FrejaMain;
const Desktop = () => {
  const activeMethod = useAtomValue(activeMethodAtom);
  return activeMethod === loginMethods.bankid ? React.createElement(BankIdMain, {
    showQR: true
  }) : React.createElement(FrejaMain, {
    showQR: true
  });
};
svs.iam_idp.components.media_queries.Desktop = Desktop;

 })(window);